import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class LanguageService {
    constructor() {
        this.langSelectedSubject = new BehaviorSubject(null);
        this.getLangObservable = this.langSelectedSubject.asObservable();
    }
    setLang(dataTest) {
        this.langSelectedSubject.next(dataTest);
    }
    returnLang() {
        return this.getLangObservable;
    }
}
LanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(); }, token: LanguageService, providedIn: "root" });
